import React from 'react';
import {Link} from 'react-router-dom';
var Backbone = require("backbone");




export default class LivingCosts extends React.Component {
	constructor(props) {
		super(props);
		
		/** ONLY DUMMY, JUST FOR DEV **/
 /*var livingcosts = Backbone.Model.extend({
 defaults: {
 selectedType: 'rent',
 costsRent: 900,
 costsLoan: 900,
 costsRunning: 200,
 calc_costsBuy: 0,
 calc_ownFunds: 0,
 calc_interests: 0,
 calc_period: 0
 }
 });
 var livingplace = Backbone.Model.extend({
 initialize: function () {
 this.set("livingcosts", new livingcosts());
 },
 defaults: {
 address: "",
 xy: "",
 targetroutes: null,
 lastinframapextent:null,
 id: "1",
 name: "Bla"
 }
 });
 var livingplaces = Backbone.Collection.extend({
 model: livingplace
 });
 var coll = new livingplaces();
 coll.add([new livingplace()])
 window.datastore.lps = coll*/
		/** ****DUMMY END***** */
			
			
		this.lpobj = window.datastore.lps.get(this.props.match.params.placeid)
		this.state = {
				placename: this.lpobj.get('name'),
				financeType: this.lpobj.get('livingcosts').get('selectedType'),
				runningcosts: this.lpobj.get('livingcosts').get('costsRunning')
		}
		
		this.handleFinanceChange = this.handleFinanceChange.bind(this);
		this.changeRunningcosts = this.changeRunningcosts.bind(this);
	}
	 handleFinanceChange(event) {
		    this.setState({financeType: event.target.value})
		    this.lpobj.get("livingcosts").set({selectedType: event.target.value})
		  }
	 
	 changeRunningcosts(e) {
		 	if (e.type === "change") {
		 		this.setState({runningcosts: e.target.value})
			    this.lpobj.get("livingcosts").set({costsRunning: parseFloat(e.target.value)})
			}
			if (e.type === "blur" && isNaN(parseInt(e.target.value))) {
				this.setState({runningcosts: 0})
			    this.lpobj.get("livingcosts").set({costsRunning: 0})
			}
		 
		 
		 
		    
		  }
	 
	render () {
		return (
				<div>
				<nav className="navbar navbar-default">
				  <div className="container-fluid header">
				  <div>
				    <ol className="breadcrumb">
				    {this.props.match.params.placeid === "2" ? <li className=""><Link to={"wohnstandorte/1/addressmap"}>Zu Wohnstandort 1</Link></li> : ''}
				    {this.props.match.params.placeid === "1" ? <li className=""><a href="/">Start</a></li> : ''}
				    <li className=""><Link to={"/wohnstandorte/"+this.props.match.params.placeid+"/addressmap"}>{this.props.match.params.placeid === "2" ? "Vergleichsstandort" : "Wohnstandort"}</Link></li>
				    <li className=""><Link to={"/wohnstandorte/"+this.props.match.params.placeid+"/infrastruktur"}>Infrastruktur</Link></li>
				    <li className="active">Wohnkosten</li>
				    <li className="not-active">Mobilität</li>
                    {this.props.match.params.placeid === "2" ? <li className="not-active">Vergleich</li> : <li className="not-active">Ergebnis</li>}
				    {this.props.match.params.placeid === "1" ? <li className="not-active">Vergleichsstandort</li> : ''}
				    </ol>
			    </div>
				  </div>
				</nav>
				<div className="container-fluid normal-page">
	    		
	    		
	    		<h4>{this.state.placename}</h4>
	    		{this.props.match.params.placeid === "2" ? <h4>(Vergleichsstandort)</h4> : ''}
	    		
	    		<h3>Laufende Wohnkosten</h3>
	    		<span className="help-block">Geben sie hier laufende Miet- oder Kreditkosten für das Wohnobjekt an</span>
	    		<hr></hr>
	    		
	    		<div className="radio">
	    		  <label>
	    		    <input type="radio" name="optionsFinance" id="optionsRent" value="rent" checked={this.state.financeType === "rent"}
	    		    onChange={this.handleFinanceChange}></input>
	    		    Miete
	    		  </label>
	    		</div>
	    		<div className="radio">
	    		  <label>
	    		    <input type="radio" name="optionsFinance" id="optionsBuy" value="buy" checked={this.state.financeType === "buy"}
	    		    onChange={this.handleFinanceChange}></input>
	    		    Kauf
	    		  </label>
	    		</div>
	    		{this.state.financeType === "rent" ? <RentInput placeid={this.props.match.params.placeid}/> : <BuyInput placeid={this.props.match.params.placeid} />}
	    		<br></br>
	    		<form>
	    		<div className="form-group">
	    		    <label htmlFor="input-runningcosts">Betriebskosten</label>
	    		    <div className="input-group">    		    
	    		    <div className="input-group-addon">€</div>
	    		    <input type="number" className="form-control" id="input-runningcosts" placeholder="€ pro Monat" value={this.state.runningcosts} onChange={this.changeRunningcosts} onBlur={this.changeRunningcosts}></input>
	    		    </div>
	    		    <span id="helpBlock" className="help-block">Geben sie hier die monatlichen Betriebskosten für das Wohnobjekt ein</span>
	    		  </div>
	    		</form>
	    		<hr></hr>
	    		<Link to={"/wohnstandorte/"+this.props.match.params.placeid+"/taeglichewege"}><button className="btn btn-default btn-primary right-button">WEITER</button></Link>
	    		</div>
	    		</div>
		)
		
	}	
}


class RentInput extends React.Component {
	constructor(props) {
		super(props);
		this.lpobj = window.datastore.lps.get(this.props.placeid)
		this.state = {
				rent: this.lpobj.get('livingcosts').get('costsRent')
		}
		this.changeRent = this.changeRent.bind(this);
	}
	changeRent(e) {
		if (e.type === "change") {
			this.setState({rent: e.target.value})
			this.lpobj.get('livingcosts').set('costsRent', parseFloat(e.target.value));
		}
		if (e.type === "blur" && isNaN(parseInt(e.target.value))) {
			this.setState({rent: 0})
			this.lpobj.get('livingcosts').set('costsRent', 0);
		}
		
		
	}
	render () {
		return (
				<form>
	    		<div className="form-group">
	    		    <label htmlFor="rent-input">Miete</label>
	    		    <div className="input-group">    		    
	    		    <div className="input-group-addon">€</div>
	    		    <input type="number" className="form-control" id="rent-input" placeholder="€ pro Monat" value={this.state.rent} onChange={this.changeRent} onBlur={this.changeRent}></input>
	    		    </div>
	    		    <span id="helpBlock" className="help-block">Geben sie hier die monatlichen Mietkosten für das Wohnobjekt ein</span>
	    		  </div>
	    		</form>
		)
		
	}
	
}

// class BuyControls extends React.Component {
// constructor(props) {
// super(props);
// this.lpobj = window.datastore.lps.get(this.props.placeid)
// this.state = {
// showCalculator: false
//				
// }
// this.handleCalculatorToggle = this.handleCalculatorToggle.bind(this);
// }
// handleCalculatorToggle(event) {
// event.preventDefault()
// this.state.showCalculator ? this.setState({showCalculator: false}) :
// this.setState({showCalculator: true})
// }
//	
// render () {
// return (<div>
//				
// <BuyInput placeid={this.props.placeid}
// showCalculator={this.state.showCalculator} />
// <button className="btn"
// onClick={this.handleCalculatorToggle}>Berechnungshilfe</button>
// </div>
// )
//		
// }
//	
// }

class BuyInput extends React.Component {
	constructor(props) {
		super(props);
		this.lpobj = window.datastore.lps.get(this.props.placeid)
		this.state = {
			costsLoan: this.lpobj.get('livingcosts').get('costsLoan'),
			calc_period: this.lpobj.get('livingcosts').get('calc_period'),
			showCalculator: false
		}
		this.changeBuyCosts = this.changeBuyCosts.bind(this);
		this.handleCalculatorToggle = this.handleCalculatorToggle.bind(this);
		this.changeLoanPeriodByInput = this.changeLoanPeriodByInput.bind(this);
		this.changeBuyCostsByCalc = this.changeBuyCostsByCalc.bind(this);
	}
	
	 changeBuyCosts(e) {
		 if (e.type === "change") {
			 this.setState({costsLoan: e.target.value})
			 this.lpobj.get('livingcosts').set('costsLoan', parseFloat(e.target.value));
			}
		 if (e.type === "blur" && isNaN(parseInt(e.target.value))) {
			 this.setState({costsLoan: 0})
			 this.lpobj.get('livingcosts').set('costsLoan', 0);
			}
		 
		  }
		
	 changeBuyCostsByCalc(number) {
			 this.setState({
				 costsLoan: number,
				 calc_period: 20
			})
			this.lpobj.get('livingcosts').set('calc_period', 20);
			this.lpobj.get('livingcosts').set('costsLoan', parseFloat(number));
		 
		 
		  }
	 changeLoanPeriodByInput(event) {
		 this.lpobj.get('livingcosts').set('calc_period', parseFloat(event.target.value));
		 this.setState({
			 calc_period: event.target.value
		})
	 }
	 
	 handleCalculatorToggle(event) {
		 	event.preventDefault()
		 	this.state.showCalculator ? this.setState({showCalculator: false}) :
		 	this.setState({showCalculator: true})
		  }
	
	render () {
		return (
				<div>
				<form>
	    		<div className="form-group">
	    		<div>
	    		<button className="btn" onClick={this.handleCalculatorToggle}>Berechnungshilfe ein/aus</button>
	    		<hr />
	    		</div>
	    		{this.state.showCalculator ? <BuyCalculator placeid={this.props.placeid} changeBuyCostsByCalc={this.changeBuyCostsByCalc}/> : ''}
	    		<label htmlFor="input-duration">Kreditlaufzeit</label>
	    		  <div className="input-group">    		    
	    		    <div className="input-group-addon">Jahre</div>
	    		    <input type="number" className="form-control" id="input-duration" placeholder="Jahre" value={this.state.calc_period} onChange={this.changeLoanPeriodByInput}></input>
	    	    </div>
	    	    <span id="helpBlock" className="help-block">Hier die Laufzeit des notwendigen Kredits angeben</span>
	    		<label htmlFor="input-buy">Kreditkosten pro Monat</label>
	    		<div className="input-group">    		    
	    		    <div className="input-group-addon">€</div>
	    		    <input type="number" className="form-control" id="input-buy" placeholder="€ pro Monat" value={this.state.costsLoan} onChange={this.changeBuyCosts} onBlur={this.changeBuyCosts}></input>
	    	    </div>
	    		    <span id="helpBlock" className="help-block">Geben sie hier die monatlichen Kreditrückzahlungskosten für das Wohnobjekt ein</span>
	    		    <span className="help-block small">Im Falle eines Barerwerbs einer Immobilie fallen keine monatlichen Kosten an. Für den Vergleich von zwei Wohnstandorten können sie in diesem Fall aber trotzdem Kosten pro Monat angeben, 
	    		    die einer typischen Miete oder Kreditfinanzierung entsprechen würden, um einen Vergleichswert zu erhalten.</span>
	    		  </div>
	    		  <div>
	    		  
	    		    <span id="helpBlock" className="help-block"></span>
	    		  </div>
	    		  
	    		</form>
	    		
	    		</div>
		)
		
	}
	
}

class BuyCalculator extends React.Component {
	constructor(props) {
		super(props);
		this.lpobj = window.datastore.lps.get(this.props.placeid)
		this.state = {
				costsBuy: this.lpobj.get('livingcosts').get('calc_costsBuy'),
				ownFunds: this.lpobj.get('livingcosts').get('calc_ownFunds')
		}
		this.calculateLoanCostsOnInputChange = this.calculateLoanCostsOnInputChange.bind(this);
	}
	calculateLoanCostsOnInputChange(event) {
		this.setState({costsBuy: event.target.value});
		this.lpobj.get('livingcosts').set('calc_costsBuy', parseFloat(event.target.value));
		
		
		var loanCostsPerMonth;
		var interests = 0.015;
		loanCostsPerMonth = (event.target.value * ( ((1 + interests)^20 * interests) / ((1 + interests)^20 -1   )   )) /12
		loanCostsPerMonth = Math.round(loanCostsPerMonth);
		this.props.changeBuyCostsByCalc(loanCostsPerMonth);
	}
	render() {
		return (
		<div className="buy-calculator">			
		<div className="form-group">
		<label htmlFor="input-costs-buy">Notwendige Kreditgesamtsumme für Kauf</label>
		<div className="input-group">
		<div className="input-group-addon">€</div>
		<input type="number" className="form-control" id="input-costs-buy" placeholder="€" value={this.state.costsBuy} onChange={this.calculateLoanCostsOnInputChange}></input>
	    </div>
		{/*
			 * <label htmlFor="input-own-funds">Eigenmittel</label> <input
			 * type="number" className="form-control" id="input-own-funds"
			 * placeholder="€" value="0"
			 * onChange={this.calculateLoanCostsOnInputChange}></input>
			 * 
			 * <label htmlFor="output-credit">Kreditbetrag</label> <input
			 * type="number" className="form-control" id="output-credit"
			 * placeholder="€" value="0" readOnly></input>
			 * 
			 * <label htmlFor="input-interest">Zinssatz</label> <input
			 * type="number" className="form-control" id="output-credit"
			 * placeholder="%" value="0"></input>
			 */}
	    </div>
	    <span id="helpBlock" className="help-block">Der damit berechnete monatliche Wert dient lediglich als einfache Orientierung. Es wird
	    dabei von einem Annuitätendarlehen bei einem Zinsatz von 1,5% und einer Laufzeit von 20 Jahren ausgegangen. 
	     <strong> Für tatsächliche Finanzierungsdaten informieren Sie sich bitte bei Kreditinstituten oder Wohnbauförderungsstellen.</strong></span>
		</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/livingcostsview.js